import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Degree } from './degree.interface';
import { DegreeService } from './degree.service';

const service = new DegreeService();

export interface DegreeState {
   degrees: Array<Degree>;
}

const DegreeStore: Module<DegreeState, StoreState> = {
   namespaced: true,
   state: {
      degrees: [],
   },
   getters: {
      degrees: (state) => state.degrees,
   },
   mutations: {
      SET_DEGREES(state, degrees: Array<Degree>) {
         state.degrees = degrees;
      },
   },
   actions: {
      async getDegrees(context, query: LocationQuery) {
         const response = await service.getDegrees({ ...query, per_page: '9999', page: '1', include: 'majors,country' });
         context.commit('SET_DEGREES', response.data);
         return response;
      },
   },
};

export default DegreeStore;
